module.exports = __webpack_public_path__ + "static/media/newsletter-may-2021-surveying.94a89ef2.jpg";